import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
    token: string | null;
    userType: "User" | "Guest" | null;
}

const initialState: AuthState = {
    token: null,
    userType: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials: (
            state: AuthState,
            action: PayloadAction<{ token: string; userType: "User" | "Guest" }>
        ) => {
            state.token = action.payload.token;
            state.userType = action.payload.userType;

            localStorage.setItem("auth_token", action.payload.token);
            localStorage.setItem("userType", action.payload.userType);
        },
        loginAsGuest: (
            state: AuthState,
        ) => {
            state.userType = "Guest";
            localStorage.setItem("userType", "Guest");
        },
        loginExpired: (state: AuthState) => {
            state.token = null;
            state.userType = null;

            localStorage.removeItem("auth_token");
            localStorage.removeItem("userType");
        },
        logout: (state: AuthState) => {
            state.token = null;
            state.userType = null;

            localStorage.removeItem("auth_token");
            localStorage.removeItem("userType");
        },
        loadFromStorage: (state: AuthState) => {
            const token = localStorage.getItem("auth_token");
            const userType = localStorage.getItem("userType") as "User" | "Guest" | null;
            state.token = token;
            state.userType = userType;
        },
    },
});

export const { setCredentials, loginAsGuest, logout, loadFromStorage, loginExpired } =
    authSlice.actions;
export default authSlice.reducer;
